<template>
<v-text-field outlined v-model="interval" :rules="rules" :label="$t('configurations.report_interval')"></v-text-field>
</template>

<script>
export default {
  name: 'ReportIntervalTextField',
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      range: [1, 3600],
      rules: [
        v => !!v || this.$t('configurations.this_is_required'),
        v => parseInt(v) <= this.range[1] || this.$t('configurations.max_is', {
          val: this.range[1]
        }),
        v => parseInt(v) >= this.range[0] || this.$t('configurations.min_is', {
          val: this.range[0]
        })
      ]
    }
  },
  computed: {
    interval: {
      get() {
        return this.value ? this.value / 1000 : '';
      },
      set(val) {
        this.$emit('input', parseInt(val) * 1000);
      }
    }
  }
}
</script>
